// extracted by mini-css-extract-plugin
export default {"defaultCard":"Yo-z","otherCards":"Zo-z","empty":"_o-z","addNewItem":"ap-z","disabled":"bp-z","cardGrid":"cp-z"};